import { type KeyDict, KisweDate, Loader } from 'kiswe-ui'
import { FanRoomScheduleTimeRange } from './FanRoomScheduleTimeRange'

export class FanRoomScheduleRow {
  name: string|null
  ranges: KeyDict<FanRoomScheduleTimeRange>

  constructor (data: unknown) {
    this.name = Loader.loadStringOrNull(data, 'name', null)
    this.ranges = Loader.loadKeyDict(data, 'ranges', (range) => new FanRoomScheduleTimeRange(range))
  }

  get sortedRangeLabels (): string[] {
    return Object.keys(this.ranges).sort((labelA, labelB) => {
      const timestampA = this.ranges[labelA]?.startTime.getTime() ?? 0
      const timestampB = this.ranges[labelB]?.startTime.getTime() ?? 0
      return timestampA - timestampB
    })
  }

  getTimeRangeMatchingDay (date: Date): FanRoomScheduleTimeRange|null {
    for (const rangeLabel of this.sortedRangeLabels) {
      const range = this.ranges[rangeLabel]
      if (range && KisweDate.isEqual(range.startTime, date, 'day')) return range
    }
    return null
  }
}
